import { BaseIllustration, BaseIllustrationProps } from '../BaseIllustration';

export type DashboardIllustrationProps = Omit<BaseIllustrationProps, 'children'>;

export const DashboardIllustration = ({ ...props }: DashboardIllustrationProps) => (
  <BaseIllustration width="64" height="64" viewBox="0 0 64 64" {...props}>
    <g strokeWidth={2} strokeMiterlimit="10" strokeLinecap="square" strokeLinejoin="miter" fill="none">
      <path d="M34.91 34.76l7.09-12.76" strokeLinecap="butt" />
      <path d="M32 3a29 29 0 1 1 0 58 29 29 0 1 1 0-58z" />
      <path d="M26 40h-14.49a22 22 0 1 1 40.98 0h-14.49" />
      <path d="M32 34a6 6 0 1 1 0 12 6 6 0 1 1 0-12z" />
    </g>
  </BaseIllustration>
);

DashboardIllustration.displayName = 'DashboardIllustration';
